// extracted by mini-css-extract-plugin
export default {"card":"AfaDocumentacionCard_card__tgASk","topSection":"AfaDocumentacionCard_topSection__T3Elv","bottomSection":"AfaDocumentacionCard_bottomSection__6d9Og"};